import $ from "jquery";
import { courseProfile } from "./courseProfile";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";
import { forms } from "../framework/forms";

let params;

function init() {
    $(document).on("change", ".js-notelevatecheckbox", function() {
        const container = $("#divFacultyEvals");
        const personId = $(this)
            .closest("tr")
            .data("personid");
        const tagId = $(this).attr("tagid");
        const elevate = $(this).is(":checked");
        const courseId = $("#courseId").val();
        params = {
            url:
                "/Course/updatedonotelevate/" +
                personId +
                "/" +
                tagId +
                "/" +
                elevate +
                "/" +
                courseId,
            successMsg: "Successfully updated Do Not Elevate."
        };
        dataaccess.post(params).done(function(results) {
            container.html(results);
            courseProfile.initPopovers();
        });
    });

    $(document).on("click", ".btnAddComment", function(e) {
        const $btn = $(this);
        const $commentError = $btn.siblings(".comment-error");
        const courseId = $("#courseId").val();
        const personId = $btn.attr("personid");
        const tagId = $btn.attr("tagid");
        const comment = $btn.siblings("textarea").val();

        if (comment.length < 1 || comment.length > 250) {
            $commentError.show();
        } else {
            $commentError.hide();
            const container = $("#divFacultyEvals");

            if ($(".popoverThis").has(e.target).length === 0) {
                $(".popoverThis").popover("hide");
            }

            const params = {
                url: "/course/addcommenttopersontag",
                contentType: dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
                data: {
                    CourseId: courseId,
                    PersonId: personId,
                    TagId: tagId,
                    Comment: comment
                },
                successMsg: "Successfully added a comment."
            };

            dataaccess.post(params).done(function(results) {
                container.html(results);
                courseProfile.initPopovers();
            });
        }
    });

    //
    // Opens modal to select monitor and sets selected Person ID
    //
    $(document).on("click", "#facultyTable .fa-plus-circle", function() {
        const isAssociateInstructorCandidate = $(this)
            .closest("tr")
            .data("isassociateinstructorcandidate");

        $("#monitor-selection-modal" + isAssociateInstructorCandidate).modal("show");
        const personId = $(this)
            .closest("tr")
            .data("personid");
        $("#monitor-selection-modal" + isAssociateInstructorCandidate + " [name='PersonId']").val(personId);
        $("#monitor-selection-modal" + isAssociateInstructorCandidate + " #IsAssociateInstructorCandidate").val(isAssociateInstructorCandidate);
    });

    //
    // Adds monitor
    //
    $(document).on("click", "input[name=MonitoredByPersonId]", function() {
        const $form = $(this).closest("form");
        const formId = $form.attr("id");
        const isAssociateInstructorCandidate = $("#" + formId + " #IsAssociateInstructorCandidate").val();
        const params = {
            contentType: dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
            data: $form.serialize(),
            url: $form.attr("action"),
            successMsg: "Successfully added monitor."
        };

        dataaccess.post(params).done(function(result) {
            $("#divFacultyEvals").html(result);
            $("#monitor-selection-modal" + isAssociateInstructorCandidate + " #RosterPersonId" + isAssociateInstructorCandidate).val("");
            courseProfile.initPopovers();
            $("#monitor-selection-modal" + isAssociateInstructorCandidate).modal("hide");
        });
    });

    //
    // Removes monitor
    //
    $(document).on("click", ".js-remove-monitor", function(e) {
        e.preventDefault();
        const courseId = $("#RosterCourseId").val();
        const personId = $(this)
            .closest("tr")
            .data("personid");

        params = {
            url: `/course/monitor?courseId=${courseId}&personId=${personId}`
        };

        dataaccess.delete(params).done(function(results) {
            $("#divFacultyEvals").html(results);
            courseProfile.initPopovers();
            services.notificationService.success("Successfully removed monitor.");
        });
    });

    $(document).on("click", ".close", function() {
        $(".popover").popover("hide");
    });

    $(document).on("click", ".popoverThis", function(e) {
        e.stopPropagation();
    });

    $(document).on("click", ".rolecardprint", printCard);

    //
    // When checkbox at top of col changes
    //
    $(document).on("change", "#selectAllStudentEvalsToggle", selectAllStudentEvalsToggle);
    //
    // Sends email about printing card
    //
    $(document).on("click", "#sendPrintCardEmail", sendPrintCardEmail);

    //
    // Save Changes button on Course Parts Dropdown
    //
    $(document).on("click", ".js-courseparts-save", function () {
        forms.showSpinner("Saving...", false);
        const checkboxes = $(this)
            .closest("tr")
            .find(".js-chk-coursepart:checkbox:checked");
        const id = $(this)
            .closest("tr")
            .attr("data-row-personid");
        let courseParts = [];
        const coursepartsToSave = $.map(checkboxes, function (elm) {
            let data = {
                id: $(elm).val(),
                name: $(elm).attr("data-coursePartName")
            };
            courseParts.push(data);
            return courseParts;
        });

        params = {
            url: "/Course/ChangeCourseParts",
            data: {
                personId: id,
                courseId: $("#courseId").val(),
                courseParts: coursepartsToSave
            }
        };
        dataaccess
            .post(params)
            .done(function () {
                populateResultsTab();
            });
        forms.hideSpinner();
    });

}

function sendPrintCardEmail() {
    $("#studentEvalTable .dropdown-toggle").dropdown("toggle");

    const checkboxes = $("#studentEvalTable").find(".js-chk-studenteval-row:checkbox:checked");

    if (checkboxes.length === 0) return;

    const objArray = [];

    checkboxes.each(function () {
        const $chk = $(this);
        const obj = {
            CourseId: $("#CourseId").val(),
            PersonId: $chk.data("personid"),
            PersonCourseId: $chk.data("personcourseid"),
            PersonRoleId: $chk.data("personroleid"),
            Program: $chk.data("program")
        };
        objArray.push(obj);
    });

    const params = {
        "data": objArray,
        "url": "/Card/StudentCardEmail",
        "successMsg": "Successfully sent emails."
    };

    forms.showSpinner("Sending...");

    dataaccess.post(params).done(function(result) {
        console.log(result);
        selectAllStudentEvalsOff();
    }).always(function() {
        forms.hideSpinner();
    });
}

function printCard() {
    const url = $(this).attr("printurl");
    forms.openPrintWindow(url);
}

//Student Evals Page Checkbox processing
function selectAllStudentEvalsToggle() {
    $(".js-chk-studenteval-row").prop("checked", $("#selectAllStudentEvalsToggle").is(":checked"));
}
function selectAllStudentEvalsOff() {
    $(".js-chk-studenteval-row").prop("checked", false);
    $("#selectAllStudentEvalsToggle").prop("checked", false);
}

function populateResultsTab() {
    const $container = $("#results");
    const courseId = $("#courseId").val();

    dataaccess.get({ url: "/Course/courseresults/" + courseId })
        .done(function (data) {
            $container.html(data);
            $.validator.unobtrusive.parse($("#studentEvalsForm"));
            courseProfile.initPopovers();
            $(".js-mask-decimal").mask("0999999.99");
        });
}


export const courseResults = {
    init: init
};
